// Footer.jsx
import React from "react";
import "../css/Footer.css";

export default function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <p>© Lucía Martinez Gavier. All rights reserved.</p>
                <p>
                    Contact: <a href="mailto:lucia@martinezgavier.com.ar">lucia@martinezgavier.com.ar</a>
                </p>
            </div>
        </footer>
    );
}
